import React from 'react';
import { AxiosError, AxiosResponse } from 'axios';
import { Grid, makeStyles } from '@material-ui/core';
import { useHistory, useLocation } from 'react-router-dom';

import { LoginAction } from '../enum/LoginAction';
import { FirstAccess } from './FirstAccess';
import { LoginInput } from './LoginInput';
import loginLateral from '../../../assets/Login_ImagemLateral.png';
import { UserContext } from '../UserContext';
import { UserModel, userModelInitial } from '../../../Models/UserModel';
import AuthService from '../../../Services/AuthService';
import { AlertDialog, alertDialogPropsInitial, IAlertDialogProps } from '../../../shared/components/AlertDialog';
import { IErrorResponse } from '../../../shared/ErrorResponse';
import { AuthContext } from '../../Authentication/AuthContext';
import { LoginModel } from '../../../Models/LoginModel';
import { ErrorHelper } from '../../../shared/ErrorHelper';
import { SendEmail } from './SendEmail';
import { ConfirmCode } from './ConfirmCode';
import { ChangePassword } from './ChangePassword';
import { LoadingDialog } from '../../../shared/components/LoadingDialog';

const useStyles = makeStyles(() => ({
    root: {
        flexGrow: 1,
    },
    img: {
        width: 'auto',
        height: '100vh',
    }
}));

export function Login() {
    const classes = useStyles();

    const auth = React.useContext(AuthContext);

    const [action, setAction] = React.useState<LoginAction>(LoginAction.LOGIN);
    const [user, setUser] = React.useState<UserModel>(userModelInitial);
    const [disableSubmit, setDisableSubmit] = React.useState<boolean>(false);
    const [alertProps, setAlertProps] = React.useState<IAlertDialogProps>(alertDialogPropsInitial);
    const [openLoadingDialog, setOpenLoadingDialog] = React.useState<boolean>(false);

    const history = useHistory();
    const location = useLocation();

    const { from }: any = location.state || { from: { pathname: '/' } };

    const login = (login: LoginModel) => {
        localStorage.setItem('loginOrigin', 'burson');
        auth.signin(login, () => {
            history.replace(from);
            setAction(LoginAction.LOGGED);
        });
    };

    function onFirstAccess() {
        AuthService
            .createFirstAccess(user)
            .then((res: AxiosResponse) => { login(res.data); })
            .catch((error: AxiosError) => { showError(error, 'Não foi possível configurar o primeiro acesso: <br/>'); });
    }

    function onLogin() {
        setOpenLoadingDialog(true);
        AuthService
            .login(user)
            .then((res: AxiosResponse) => {
                setOpenLoadingDialog(false);
                login(res.data);
            })
            .catch((error: AxiosError) => {
                setOpenLoadingDialog(false);
                showError(error, 'Não foi possível realizar o login: <br/>');
            });
    }

    const showError = (error: AxiosError, message: string) => {
        const errorResponse: IErrorResponse = ErrorHelper(error);
        setAlertProps({
            message: message + errorResponse.message,
            severity: 'error',
            open: true,
            onClose: () => { setAlertProps({ ...alertProps, open: false }); }
        });
    };

    function onSendPasswordRecoveryEmail() {
        setOpenLoadingDialog(true);
        AuthService
            .sendEmailPasswordRecovery(user)
            .then(() => {
                setOpenLoadingDialog(false);
                setAction(LoginAction.CODE_CONFIRMATION_PASSWORD_RECOVERY);
            })
            .catch((error: AxiosError) => {
                setOpenLoadingDialog(false);
                showError(error, '');
            });
    }


    return (
        <>
            <div className={classes.root}>
                <Grid
                    container
                    direction="row"
                    alignItems="center"
                    justify='space-around'>
                    <img className={classes.img} alt="complex" src={loginLateral} />
                    <UserContext.Provider value={{
                        user, setUser,
                        disableSubmit, setDisableSubmit,
                    }}>
                        <Grid
                            item
                            xs
                            container
                            direction="column"
                            alignItems="center">
                            {action === LoginAction.LOGIN && (
                                <LoginInput
                                    onClick={onLogin}
                                    onBack={() => setAction(LoginAction.FIRST_ACCESS)}
                                    onPasswordRecovery={() => {
                                        setAction(LoginAction.SEND_EMAIL_PASSWORD_RECOVERY);
                                        const userData = user;
                                        userData.password = '';
                                        userData.recoveryCode = '';
                                        setUser(userData);
                                    }} />
                            )}
                            {action === LoginAction.FIRST_ACCESS && (
                                <FirstAccess
                                    onClick={onFirstAccess}
                                    onBack={() => setAction(LoginAction.LOGIN)} />
                            )}
                            {action === LoginAction.SEND_EMAIL_PASSWORD_RECOVERY && (
                                <SendEmail
                                    onClick={onSendPasswordRecoveryEmail}
                                    onBack={() => setAction(LoginAction.LOGIN)} />
                            )}
                            {action === LoginAction.CODE_CONFIRMATION_PASSWORD_RECOVERY && (
                                <ConfirmCode
                                    onBack={() => setAction(LoginAction.SEND_EMAIL_PASSWORD_RECOVERY)} />
                            )}
                        </Grid>
                    </UserContext.Provider>
                </Grid>
            </div>
            <AlertDialog
                message={alertProps.message}
                onClose={alertProps.onClose}
                open={alertProps.open}
                severity={alertProps.severity} />
            <LoadingDialog open={openLoadingDialog} />
        </>
    );
}